// import React, { useState, useEffect } from "react";
// import DropDownNTS from "../CreateNTS/dropdownSpan";
// import "../CreateNTS/newTestSeries.css";
// import Swal from "sweetalert2";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import { useSelector, useDispatch } from "react-redux";

// const NTSV2 = (dataClient) => {
//   const [courses, setCourses] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [selectedCourseId, setSelectedCourseId] = useState(null);
//   const [selectedClassId, setSelectedClassId] = useState(null);
//   const [selectedSubjectId, setSelectedSubjectId] = useState(null);
//   const [selectedTestId, setTestID] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [time, setTime] = useState("");
//   const [timeMinutes, setTimeMinutes] = useState("");
//   const [selectedSchemeId, setSelectedSchemeId] = useState(null);
//   const [markingSchemes, setMarkingSchemes] = useState([]);
//   const [selectedTest, setSelectedTest] = useState(null);
//   const [seriesName, setSeriesName] = useState("");
//   const [description, setDescription] = useState("");
//   const [totalQuestions, setTotalQuestions] = useState("");
//   const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
//   const clientBranchId =
//     dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
//   const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
//   const [subjectDetails, setSubjectDetails] = useState([]);

//   useEffect(() => {
//     fetch(`${FULL_API_BASE_URL}/get-courses/`)
//       .then((response) => response.json())
//       .then((data) => setCourses(data))
//       .catch((error) => console.error("Error:", error));

//     fetch(`${FULL_API_BASE_URL}/get-classes/`)
//       .then((response) => response.json())
//       .then((data) => setClasses(data))
//       .catch((error) => console.error("Error:", error));
//   }, []);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetch(
//         `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`
//       )
//         .then((response) => response.json())
//         .then((data) => setSubjects(data))
//         .catch((error) => console.error("Error:", error));
//     }
//   }, [selectedCourseId]);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetch(
//         `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`
//       )
//         .then((response) => response.json())
//         .then((data) => {
//           setSubjects(data);
//           setSubjectDetails(
//             data.map((subject) => ({
//               subject_id: subject.subject_id,
//               total_ques_count: 0,
//               mandatory_count: 0,
//               optional_attempt_count: 0,
//               optional_total_count: 0,
//               optional_numeric: 0,
//             }))
//           );
//         })
//         .catch((error) => console.error("Error:", error));
//     }
//   }, [selectedCourseId]);

//   const [tableTotalQuestions, setTableTotalQuestions] = useState(0);

//   const handleInputChangeInTable = (index, field, value) => {
//     const newSubjectDetails = [...subjectDetails];
//     if (field === "optional_attempt_count") {
//       newSubjectDetails[index][field] = parseInt(value) || 0;
//     } else {
//       newSubjectDetails[index][field] = value;
//     }
//     setSubjectDetails(newSubjectDetails);

//     if (field === "total_ques_count") {
//       const total = newSubjectDetails.reduce(
//         (sum, detail) => sum + (parseInt(detail.total_ques_count) || 0),
//         0
//       );
//       setTableTotalQuestions(total);
//     }
//   };

//   const borderColor =
//     totalQuestions !== tableTotalQuestions ? "input-details-nts" : "black";

//   const handleCancel = () => {
//     Swal.fire({
//       title: "Are you sure you want to cancel?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//       confirmButtonColor: "rgb(100 101 101)",
//       cancelButtonColor: "#318682",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         window.location.reload();
//       }
//     });
//   };

//   const validateInput = (subjectDetailsInt) => {
//     for (let detail of subjectDetailsInt) {
//       if (
//         !(
//           detail.optional_total_count === 0 ||
//           detail.optional_total_count === "" ||
//           detail.optional_attempt_count < detail.optional_total_count
//         ) &&
//         detail.mandatory_count + detail.optional_total_count ==
//           detail.total_ques_count
//       ) {
//         return false;
//       }
//     }
//     return true;
//   };

//   useEffect(() => {
//     fetch(
//       `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`
//     )
//       .then((response) => response.json())
//       .then((data) => setMarkingSchemes(data.data))
//       .catch((error) => console.error("Error:", error));
//   }, []);

//   const handleSave = () => {
//     if (subjectDetails.length === 0) {
//       Swal.fire({
//         title: "No Input Data",
//         text: "Please provide some subject details.",
//         icon: "error",
//         confirmButtonText: "OK",
//         confirmButtonColor: "rgb(100 101 101)",
//       });
//       return;
//     }

//     const subjectDetailsInt = subjectDetails.map((detail) => ({
//       ...detail,
//       total_ques_count: parseInt(detail.total_ques_count),
//       mandatory_count: parseInt(detail.mandatory_count),
//       optional_attempt_count: parseInt(detail.optional_attempt_count),
//       optional_total_count: parseInt(detail.optional_total_count),
//       optional_numeric: parseInt(detail.optional_numeric),
//     }));

//     if (parseInt(totalQuestions) !== tableTotalQuestions) {
//       Swal.fire({
//         title: "Input Error",
//         text: "The total number of questions does not match the sum of subject-wise questions.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return;
//     }

//     if (!validateInput(subjectDetailsInt)) {
//       Swal.fire({
//         title: "Input Error",
//         text: "Please check your input values.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return;
//     }

//     const url = `${FULL_API_BASE_URL}/test-series?series_name=${seriesName}&description=${description}&course_id=${selectedCourseId}&class_id=${selectedClassId}&ms_id=${selectedSchemeId}&duration_mins=${timeMinutes}&total_questions=${totalQuestions}&test_mode_id=${selectedTestId}&user_name=${user_name}&client_id=${clientId}&client_branch_id=${clientBranchId}`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(subjectDetailsInt),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log(data);

//         Swal.fire({
//           title: "Test Series Created Successfully",
//           icon: "success",
//           timer: 2000,
//           confirmButtonColor: "#318682",
//         }).then(() => {
//           setTimeout(function () {
//             window.location.reload();
//           }, 100);
//         });
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   };

//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedSection, setSelectedSection] = useState(null);
//   const [addedSubjects, setAddedSubjects] = useState({}); // Track added subjects and sections

//   // Simulated subject list and section options
//   const subjectList = ["PHYSICS", "ZOOLOGY", "CHEMISTRY", "BIOLOGY"];
//   const sectionList = [
//     "SINGLE CORRECT",
//     "MULTI CORRECT",
//     "MATCH THE COLUMNS",
//     "FILL IN THE BLANKS",
//   ];

//   const handleAddSubject = () => {
//     if (selectedSubject) {
//       setAddedSubjects((prev) => ({
//         ...prev,
//         [selectedSubject]: prev[selectedSubject] || [], // Initialize with an empty array if new
//       }));
//       setSelectedSubject(null); // Reset after adding
//     }
//   };

//   const handleAddSection = () => {
//     if (selectedSubject && selectedSection) {
//       setAddedSubjects((prev) => ({
//         ...prev,
//         [selectedSubject]: [...(prev[selectedSubject] || []), selectedSection], // Add section under the selected subject
//       }));
//       setSelectedSection(null); // Reset after adding
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="container-UP" style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <p className="title-cb">Create New Test Series V2</p>
//           <div className="mb-2-UP">
//             <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
//               CANCEL
//             </button>
//             <button className="cr-create-btn" onClick={handleSave}>
//               SAVE
//             </button>
//           </div>
//         </div>
//         <hr
//           style={{
//             color: "red",
//             backgroundColor: "red",
//             marginTop: "5px",
//           }}
//         />
//       </div>
//       <div className="container-cs-fluid ms-cs3 mt-cs3">
//         <div className=" ">
//           <div className=" transparent-margin-left ">
//             <div className="row-cs-uni">
//               <div className="col-cs">
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div style={{ width: "28%" }}>Name</div>
//                   <input
//                     type="text"
//                     style={{
//                       width: "50%",
//                       marginTop: "10px",
//                       marginLeft: "10px",
//                       marginBottom: "5px",
//                       height: "30px",
//                       padding: "10px",
//                       outline: "none",
//                       color: "#6a6a6a",
//                     }}
//                     value={seriesName}
//                     onChange={(e) => setSeriesName(e.target.value)}
//                   />
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div style={{ width: "28%" }}>Course</div>
//                   <DropDownNTS
//                     style={{
//                       width: "50%",
//                       marginTop: "5px",
//                       marginLeft: "10px",
//                       color: "#6a6a6a",
//                     }}
//                     selected={selectedCourseId}
//                     setSelected={(value) => {
//                       setSelectedCourseId(value);
//                       const newSubjectDetails = subjectDetails.map(
//                         (detail) => ({
//                           ...detail,
//                           optional_numeric:
//                             value === 2 ? detail.optional_numeric : 0,
//                         })
//                       );
//                       setSubjectDetails(newSubjectDetails);
//                     }}
//                     options={courses.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_name,
//                     }))}
//                   />
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div style={{ width: "28%" }}>Scope</div>
//                   <DropDownNTS
//                     style={{
//                       width: "50%",
//                       marginTop: "5px",
//                       marginLeft: "10px",
//                       marginBottom: "10px",
//                       color: "#6a6a6a",
//                     }}
//                     selected={selectedTest}
//                     setSelected={(value) => {
//                       setSelectedTest(value);
//                       setTestID(value);
//                     }}
//                     options={[
//                       { id: 1, label: "SCOPE!" },
//                       { id: 2, label: "SCOPE2" },
//                       { id: 3, label: "SCOPE3" },
//                     ]}
//                   />
//                 </div>
//               </div>
//               <div className="col-cs">
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div style={{ width: "28%" }}>Class</div>
//                   <DropDownNTS
//                     style={{
//                       width: "50%",
//                       marginTop: "5px",
//                       marginLeft: "10px",
//                       color: "#6a6a6a",
//                     }}
//                     selected={selectedClassId}
//                     setSelected={setSelectedClassId}
//                     options={classes.map((cls) => ({
//                       id: cls.class_id,
//                       label: cls.class_name,
//                     }))}
//                   />
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div style={{ width: "28%" }}>Test Mode</div>
//                   <DropDownNTS
//                     style={{
//                       width: "50%",
//                       marginTop: "5px",
//                       marginLeft: "10px",
//                       marginBottom: "10px",
//                       color: "#6a6a6a",
//                     }}
//                     selected={selectedTest}
//                     setSelected={(value) => {
//                       setSelectedTest(value);
//                       setTestID(value);
//                     }}
//                     options={[
//                       { id: 1, label: "Online" },
//                       { id: 2, label: "Offline" },
//                       { id: 3, label: "Hybrid" },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div
//               style={{ width: "30vw", marginLeft: "2vw", marginTop: "2vh" }}
//             ></div>
//           </div>
//         </div>
//       </div>
//       <hr
//         style={{
//           width: "98%",
//           marginLeft: "18px",
//           borderTop: "1px dashed grey",
//           marginTop: "20px",
//         }}
//       />
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "20px",
//           marginBottom: "40px",
//         }}
//       >
//         {/* Existing Header and Main Layout */}
//         {/* SUBJECTS Selection Section */}
//         <h3 style={{ padding: "15px", color: "grey" }}>SUBJECTS</h3>
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr 2fr",
//             alignItems: "start",
//             gap: "10px",
//           }}
//         >
//           {/* First Column: Subjects */}
//           <div style={{ gridColumn: "1", marginLeft: "18px" }}>
//             <div
//               style={{
//                 marginBottom: "10px",
//                 padding: "10px",
//                 width: "20vw",
//                 border: "1px dotted grey",
//               }}
//             >
//               {subjectList.map((subject) => (
//                 <div
//                   key={subject}
//                   onClick={() => setSelectedSubject(subject)}
//                   style={{
//                     padding: "4px",
//                     backgroundColor:
//                       selectedSubject === subject ? "lightblue" : "transparent",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {subject}
//                 </div>
//               ))}
//             </div>

//             {/* Second Column: Sections */}
//             <div
//               style={{
//                 padding: "10px",
//                 width: "20vw",
//                 border: "1px dotted grey",
//               }}
//             >
//               {sectionList.map((section) => (
//                 <div
//                   key={section}
//                   onClick={() => setSelectedSection(section)}
//                   style={{
//                     padding: "4px",
//                     backgroundColor:
//                       selectedSection === section
//                         ? "lightgreen"
//                         : "transparent",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {section}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Middle Column: Add Buttons */}
//           <div
//             style={{
//               gridColumn: "2",
//               display: "flex",
//               flexDirection: "column",
//               gap: "10px",
//               alignItems: "center",
//             }}
//           >
//             <button style={{ marginTop: "8vh" }} onClick={handleAddSubject}>
//               ADD SUBJECT
//             </button>
//             <button style={{ marginTop: "3vh" }} onClick={handleAddSection}>
//               ADD SECTION
//             </button>
//           </div>

//           {/* Right Column: Display added subjects and sections */}
//           <div
//             style={{
//               gridColumn: "3",
//               padding: "10px",
//               width: "98%",
//               border: "1px dotted grey",
//             }}
//           >
//             {Object.keys(addedSubjects).map((subject) => (
//               <div key={subject}>
//                 <strong>{subject}</strong>
//                 <ul style={{ marginLeft: "27px" }}>
//                   {addedSubjects[subject].map((section, index) => (
//                     <li key={`${subject}-${index}`}>{section}</li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NTSV2;
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import DropDownNTS from "../CreateNTS/dropdownSpan";
import "../CreateNTS/newTestSeries.css";
import Swal from "sweetalert2";
import { FULL_API_BASE_URL } from "../../Config/Config";
import { useSelector, useDispatch } from "react-redux";

const NTSV2 = (dataClient) => {
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate(); // Initialize navigate
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedTestId, setTestID] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [seriesName, setSeriesName] = useState("");
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const [subjectDetails, setSubjectDetails] = useState([]);

  useEffect(() => {
    fetch(`${FULL_API_BASE_URL}/get-courses/`)
      .then((response) => response.json())
      .then((data) => setCourses(data))
      .catch((error) => console.error("Error:", error));

    fetch(`${FULL_API_BASE_URL}/get-classes/`)
      .then((response) => response.json())
      .then((data) => setClasses(data))
      .catch((error) => console.error("Error:", error));
  }, []);

  useEffect(() => {
    if (selectedCourseId) {
      fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`
      )
        .then((response) => response.json())
        .then((data) => setSubjects(data))
        .catch((error) => console.error("Error:", error));
    }
  }, [selectedCourseId]);

  useEffect(() => {
    if (selectedCourseId) {
      fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourseId}`
      )
        .then((response) => response.json())
        .then((data) => {
          setSubjects(data);
          setSubjectDetails(
            data.map((subject) => ({
              subject_id: subject.subject_id,
              total_ques_count: 0,
              mandatory_count: 0,
              optional_attempt_count: 0,
              optional_total_count: 0,
              optional_numeric: 0,
            }))
          );
        })
        .catch((error) => console.error("Error:", error));
    }
  }, [selectedCourseId]);

  // const handleCancel = () => {
  //   Swal.fire({
  //     title: "Are you sure you want to cancel?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     confirmButtonColor: "rgb(100 101 101)",
  //     cancelButtonColor: "#318682",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       window.location.reload();
  //     }
  //   });
  // };

  const handleSave = () => {};
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [addedSubjects, setAddedSubjects] = useState({});

  const subjectList = ["PHYSICS", "ZOOLOGY", "CHEMISTRY", "BIOLOGY"];
  const sectionList = [
    "SINGLE CORRECT",
    "MULTI CORRECT",
    "MATCH THE COLUMNS",
    "FILL IN THE BLANKS",
  ];

  // Section descriptions
  const sectionDescriptions = {
    "SINGLE CORRECT": "There is only one correct option",
    "MULTI CORRECT": "There are multiple correct options",
    "MATCH THE COLUMNS": "Match the column to the correct option",
    "FILL IN THE BLANKS": "Fill in the appropriate value in the blanks",
  };

  const handleAddSubject = () => {
    if (selectedSubject) {
      setAddedSubjects((prev) => ({
        ...prev,
        [selectedSubject]: prev[selectedSubject] || [],
      }));
    }
  };

  const handleAddSection = () => {
    if (selectedSubject && addedSubjects[selectedSubject]) {
      setAddedSubjects((prev) => ({
        ...prev,
        [selectedSubject]: [...prev[selectedSubject], selectedSection],
      }));
      setSelectedSection(null);
    } else {
      Swal.fire({
        title: "Subject Not Added",
        text: "Please add the subject first before adding a section.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <p className="title-cb">Create New Test Series V2</p>
          <div className="mb-2-UP">
            <button
              className="cr-cancel-btn me-cs4"
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>

            <button className="cr-create-btn" onClick={handleSave}>
              SAVE
            </button>
          </div>
        </div>
        <hr
          style={{
            color: "red",
            backgroundColor: "red",
            marginTop: "5px",
          }}
        />
      </div>
      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className=" ">
          <div className=" transparent-margin-left ">
            <div className="row-cs-uni">
              <div className="col-cs">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Name</div>
                  <input
                    type="text"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginLeft: "10px",
                      marginBottom: "5px",
                      height: "30px",
                      padding: "10px",
                      outline: "none",
                      color: "#6a6a6a",
                    }}
                    value={seriesName}
                    onChange={(e) => setSeriesName(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Course</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedCourseId}
                    setSelected={(value) => {
                      setSelectedCourseId(value);
                      const newSubjectDetails = subjectDetails.map(
                        (detail) => ({
                          ...detail,
                          optional_numeric:
                            value === 2 ? detail.optional_numeric : 0,
                        })
                      );
                      setSubjectDetails(newSubjectDetails);
                    }}
                    options={courses.map((course) => ({
                      id: course.course_id,
                      label: course.course_name,
                    }))}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Scope</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedTest}
                    setSelected={(value) => {
                      setSelectedTest(value);
                      setTestID(value);
                    }}
                    options={[
                      { id: 1, label: "SCOPE!" },
                      { id: 2, label: "SCOPE2" },
                      { id: 3, label: "SCOPE3" },
                    ]}
                  />
                </div>
              </div>
              <div className="col-cs">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Class</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedClassId}
                    setSelected={setSelectedClassId}
                    options={classes.map((cls) => ({
                      id: cls.class_id,
                      label: cls.class_name,
                    }))}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Test Mode</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedTest}
                    setSelected={(value) => {
                      setSelectedTest(value);
                      setTestID(value);
                    }}
                    options={[
                      { id: 1, label: "Online" },
                      { id: 2, label: "Offline" },
                      { id: 3, label: "Hybrid" },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div
              style={{ width: "30vw", marginLeft: "2vw", marginTop: "2vh" }}
            ></div>
          </div>
        </div>
      </div>
      <hr
        style={{
          width: "98%",
          marginLeft: "18px",
          borderTop: "1px dashed grey",
          marginTop: "20px",
        }}
      />
      <div
        style={{
          height: "auto",
          width: "100%",
          paddingLeft: "20px",
          marginBottom: "40px",
        }}
      >
        <h3 style={{ padding: "15px", color: "grey" }}>
          SUBJECTS & SECTIONS CUSTOMIZATION
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 2fr",
            alignItems: "start",
            gap: "10px",
          }}
        >
          {/* First Column: Subjects */}
          <div style={{ gridColumn: "1", marginLeft: "18px" }}>
            <div
              style={{
                marginBottom: "10px",
                padding: "10px",
                width: "20vw",
                border: "1px dotted grey",
              }}
            >
              {subjectList.map((subject) => (
                <div
                  key={subject}
                  onClick={() => setSelectedSubject(subject)}
                  style={{
                    padding: "4px",
                    backgroundColor:
                      selectedSubject === subject ? "#FFBD20" : "transparent",
                    cursor: "pointer",
                  }}
                >
                  {subject}
                </div>
              ))}
            </div>

            {/* Second Column: Sections */}
            <div
              style={{
                padding: "10px",
                width: "20vw",
                border: "1px dotted grey",
                marginTop: "30px",
              }}
            >
              {sectionList.map((section) => (
                <div
                  key={section}
                  onClick={() => setSelectedSection(section)}
                  style={{
                    padding: "4px",
                    backgroundColor:
                      selectedSection === section ? "#FFBD20" : "transparent",
                    cursor: "pointer",
                  }}
                >
                  {section}
                </div>
              ))}
            </div>
          </div>

          {/* Middle Column: Add Buttons and Description */}
          <div
            style={{
              gridColumn: "2",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <button
              className="btn-ntsv2"
              style={{ marginTop: "8vh" }}
              onClick={handleAddSubject}
            >
              ADD SUBJECT
            </button>
            <button
              className="btn-ntsv2"
              style={{ marginTop: "3vh" }}
              onClick={handleAddSection}
            >
              ADD SECTION
            </button>

            {/* Description Section */}
            {selectedSection && (
              <div
                className="description-ntsv2"
                style={{
                  border: "1px solid #FFBD20",
                  marginTop: "8vh",
                  padding: "10px",
                  width: "80%",
                }}
              >
                <p>
                  <strong>{selectedSection}</strong>:{" "}
                  {sectionDescriptions[selectedSection]}
                </p>
              </div>
            )}
          </div>

          {/* Right Column: Display added subjects and sections */}
          <div
            style={{
              gridColumn: "3",
              padding: "10px",
              width: "98%",
              border: "1px dotted grey",
            }}
          >
            {Object.keys(addedSubjects).map((subject) => (
              <div key={subject}>
                <strong>{subject}</strong>
                <ul style={{ marginLeft: "27px" }}>
                  {addedSubjects[subject].map((section, index) => (
                    <li key={`${subject}-${index}`}>{section}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NTSV2;
